import {AxiosResponse } from 'axios';

import apiClient from '../client';
import { PageResultDto } from 'interfaces/page';
import { CompanyDto, CreateCompanyDto, UpdateCompanyDto } from 'interfaces/companies/company';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface CompanyService {
  search(queryParams?: any): Promise<PageResultDto<CompanyDto>>
  getCompany(id: string): Promise<CompanyDto>
  createCompany(postData: CreateCompanyDto): Promise<CompanyDto>
  editCompany(id: string, postData: UpdateCompanyDto): Promise<AxiosResponse<CompanyDto>>
}

const COMPANY_PATH = '/companies';

const endpoints = {
  search: COMPANY_PATH,
  getCompany: (id: string) => `${COMPANY_PATH}/${id}`,
  createCompany: COMPANY_PATH,
  editCompany: (id: string) => `${COMPANY_PATH}/${id}`,
}

export const companiesService: CompanyService = {
  search: async (queryParams?: any): Promise<PageResultDto<CompanyDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<CompanyDto>>> = await apiClient.get(endpoints.search, {params: {...queryParams}, paramsSerializer: {indexes: null}});

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  getCompany: async (id: string): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.get(endpoints.getCompany(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  createCompany: async (postData: any): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.post(endpoints.createCompany, postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  editCompany: async (id: string, postData: any): Promise<AxiosResponse<CompanyDto>> => {
    return apiClient.put(endpoints.editCompany(id), postData);
  },
}
